import { useEffect, useState } from 'react';
import styles from './ProofPopup.module.sass';
import 'animate.css';

export default function ProofPopup({ data }) {
  // STATE
  const [index, setIndex] = useState(0);
  const [animation, setAnimation] = useState(null);
  const [isOff, setOff] = useState(false);

  // VARS
  const item = data[index];
  const delay = 5000;
  const showTime = 10000;

  // EFFECTS
  useEffect(() => {
    if (data.length > 0 && !animation) {
      setTimeout(() => {
        showPopup(index);
      }, delay);

      setTimeout(() => {
        hidePopup(index);
      }, delay + showTime);
    }
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (data.length > 0) {
      setTimeout(() => {
        showPopup(index);
      }, delay);

      setTimeout(() => {
        hidePopup(index);
      }, delay + showTime);
    }
    // eslint-disable-next-line
  }, [index]);

  // UTILS
  function showPopup(index) {
    if (data[index]) {
      setAnimation('animate__fadeInUp');
    }
  }

  function hidePopup(index) {
    setAnimation('animate__fadeOutDown');

    if (data[index + 1]) {
      setTimeout(() => {
        setIndex(index + 1);
      }, 500);
    } else {
      setTimeout(() => {
        setIndex(0);
      }, 500);
    }
  }

  // RENDER
  if (!animation || isOff) return null;

  return (
    <div className={`${styles.popup} animate__animated ${animation} animate__faster`}>
      <div className={styles.close} onClick={() => setOff(true)}>
        <i className='far fa-times-circle'></i>
      </div>
      <div className={styles.image}>
        <img src={item.image} width={70} height={70} alt={item.product} />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>
          {item.name} from {item.city}
        </div>
        <div className={styles.text}>purchased {item.product}</div>
        <div className={styles.date}>{item.date}</div>
        <div className={styles.link}>
          <i className='fas fa-check-circle'></i> by <span>{item.company}</span>
        </div>
      </div>
    </div>
  );
}
